import React, { Fragment } from 'react';
import PropTypes, { object } from 'prop-types';

import {
  Table,
  Member,
  DateTime,
  CutIfToltip,
  TableCell
} from 'components/common/Elements/Elements';

import { getInitialsFull } from 'utils/common';

import classes from './NpsTable.module.scss';

const TableRow = ({ company, tableConf, row, mouseEnter }) => {
  return (
    <Table.Row className={classes.row}>
      {tableConf.map(({ title, show, field }, ind) => {
        const cellProps = {
          row: row,
          mouseEnter: mouseEnter,
          ind: ind,
          field: field,
          classes: classes
        };

        return (
          <Fragment key={`${title}-${company._id}}`}>
            {show && field === 'firstName' && (
              <TableCell cellProps={cellProps}>
                <Member
                  member={{
                    fullName: company.fullName,
                    description: company.email,
                    initials: getInitialsFull(company.fullName)
                  }}
                />
              </TableCell>
            )}
            {show && field === 'role' && (
              <TableCell cellProps={cellProps}>{company.role}</TableCell>
            )}
            {show && field === 'comment' && (
              <TableCell cellProps={cellProps}>
                <CutIfToltip data={company.comment} length={100} />
              </TableCell>
            )}
            {show && field === 'score' && (
              <TableCell cellProps={cellProps}>{company.score}</TableCell>
            )}
            {show && field === 'lastUpdatedAt' && (
              <TableCell cellProps={cellProps}>
                <DateTime date={company.lastUpdatedAt} time />
              </TableCell>
            )}
          </Fragment>
        );
      })}
    </Table.Row>
  );
};

TableRow.propTypes = {
  company: PropTypes.object,
  tableConf: PropTypes.arrayOf(object),
  row: PropTypes.string,
  mouseEnter: PropTypes.func
};

export default TableRow;
